import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import email from './emailSupportText';

const useStyles = makeStyles((theme: any) => ({
  support: {
    color: ({ inheritColor }: any) => {
      return inheritColor ? 'inherit' : theme.palette.primary.main;
    },
    fontSize: ({ fontSize }: any) => {
      return fontSize + 'em';
    },
    textDecoration: 'none',
  },
}));

export default function EmailSupport(props) {
  const { fontSize = 1.1, inheritColor = false } = props;
  const classes = useStyles({ fontSize, inheritColor });

  return (
    <a
      className={classes.support}
      href={`mailto:${email.to}?subject=${email.subject.replace(
        ' ',
        '%20',
      )}&body=${email.body.replace(' ', '%20')}`}
    >
      {props.text}
    </a>
  );
}
